import Tools from '../../../tools.js';
import API from '../../../api';
import Enums from '../../../enums.js';

import React, { useState, useEffect } from "react";
import { Button, Container, Row, Col, Form, Card } from 'react-bootstrap';
import { useMappedState, useDispatch } from 'redux-react-hook';
import ChargeCalculatorPartApp from '../../Charge/ChargeCalculatorPartApp.js';
import { useCookies } from 'react-cookie';

export default function QuestTargetCustNormalApp(props) {
    const formRef = React.createRef();
    const [isFetched, setIsFetched] = useState(false);
    const [isAPISending, setIsAPISending] = useState(false);
    const [subStep, setSubStep] = useState(1);
    const [pi, setPi] = useState(props.pi || "");
    const [order, setOrder] = useState(null);
    const [targetList, setTargetList] = useState([]);
    const [items, setItems] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(['point']);
    // const [max_people_tmp, setMaxPeopleTmp] = useState(props.pdata.max_people);
    const [targetData, setTargetData] = useState({
        max_people: 0,
        gender: 0,
        age: 0,
        region: 0,
        discount: 0
    });
    const [isGetFormData, setIsGetFormData] = useState(false);
    const [formData, setFormData] = useState(null);
    // const tmpItems = useMappedState(state => state.tmpItems);
    // const dispatch = useDispatch();

    useEffect(() => {
        console.log("updated", isFetched);
        if (false == isFetched) {
            // console.log(this);
            // console.log(props);
            // Tools.init();
            getData();
        }
        setIsFetched(true);
    }, [isFetched]);

    useEffect(() => {
        if (order != null && false == isGetFormData) {
            getOnlinePayData();
            setIsGetFormData(true);
        }
    }, [order]);

    function getData() {
        // if (props.oid) {
        //     var tmpData = {
        //         oid: props.oid
        //     };
        //     API.GetOrders(tmpData).
        //         then(onOrderUpdated);
        // } else {
        var tmpData = {
            pi: pi
        };
        API.GetQuestionnaire(tmpData).
            then(onDataUpdated);
        // }
    }

    function onOrderUpdated(data) {
        console.log(data);
        if (data && data.data
            && data.data.length && data.data.length > 0
            && null != data.data[0]) {
            let tmp = data.data[0];
            // {
            //     formula_text: "(題目數 5 * 樣本數 5 * 性別控樣係數 1.50 * 年齡控樣係數 1.30 * 地區控樣係數 2.00 = 97)"
            //     oid: "ORD210824233618"
            //     platform_point: 97
            //     price: 582
            // }
            setOrder({
                oid: tmp.oid,
                // formula_text: tmp.details[0].description,
                platform_point: tmp.t_platform_point,
                price: tmp.price,
                state: tmp.state
            })
            setSubStep(2);
        }
    }

    function onDataUpdated(data) {
        if (data && data.response
            && data.response.status == 200 && data.responseData) {
            setItems(data.responseData);
        }
    }

    function toNext(data) {
        setSubStep(2);
    }
    function back(data) {
        props.onBackToList();
    }

    function onConditionSet(data, callback) {
        let tmpData = {
            ...data,
            pid: pi
        }
        setTargetData(tmpData);
        //--------- API not working ----------
        API.AddProjectOrder(tmpData).
            then((data) => {
                console.log(data);
                if (data) {
                    if (data.msg) {
                        //{msg: "訂單已付款", code: "23057"}
                        alert(data.msg);
                    }
                    if (null != data.oid) {
                        // {
                        //     formula_text: "(題目數 5 * 樣本數 5 * 性別控樣係數 1.50 * 年齡控樣係數 1.30 * 地區控樣係數 2.00 = 97)"
                        //     oid: "ORD210824233618"
                        //     platform_point: 97
                        //     price: 582
                        // }
                        setOrder({ ...data })
                        callback();
                    } else return;
                } else {
                    alert("Server error");
                }
            });

        // if (true == check) {
        //     setIsSending(true);
        //     API.AddProject({
        //         ty: 2,
        //         pi: pi
        //     }, projData)
        //         .then(response => {
        //             console.log(response);

        //             if (response && response.responseData) {
        //                 console.log(response.responseData.code);
        //                 setIsSending(false);
        //                 if (response.responseData.code == "22000") {
        //                     setSubStep(2);
        //                     props.onNextStep(targetData);
        //                 } else {
        //                     alert(response.responseData.msg);
        //                 }
        //             }
        //         }) // JSON from `response.json()` call
        //         .catch(error => console.error(error)); //head, body
        // } else {
        //     alert("年齡限制為15~75歲");
        //     setTargetData(tmp);
        // }
    }

    function getOnlinePayData() {
        console.log(order);
        let succRedirectUrl = "https://nezcdev.dataa.com.tw/back/order/v1/PaymentRedirect?return="
            + encodeURIComponent(`${window.location.origin}/#/proj/edit/${pi}/4/${order.oid}/`);
        console.log(succRedirectUrl);

        let tmpData = {
            oid: order.oid,
            return_url: succRedirectUrl,        //when finish payment
            client_back_url: succRedirectUrl    //when click back
        }
        //--------- API not working ----------
        API.OrderOnlinePayment(tmpData).
            then((data) => {
                console.log(data);
                if (data.URL
                    && data.Method
                    && data.MerchantID
                    && data.TradeInfo
                    && data.TradeSha
                    && data.Version) {
                    setFormData(data);
                } else {
                    if (data.msg) alert(data.msg);
                    else alert("server error");
                    console.log(data);
                }
                //     // {
                //     //     formula_text: "(題目數 5 * 樣本數 5 * 性別控樣係數 1.50 * 年齡控樣係數 1.30 * 地區控樣係數 2.00 = 97)"
                //     //     oid: "ORD210824233618"
                //     //     platform_point: 97
                //     //     price: 582
                //     // }
                //     setOrder({ ...data })
                //     setSubStep(2);
                // } else {
                //     alert("Server error");
            });
    }

    function onClickOnlinePay() {
        //trigger form click
        console.log(formRef);
        formRef.current.submit();
    }

    function onClickPointPay() {
        setIsAPISending(true);
        let tmpData = {
            oid: order.oid
        }
        //--------- API not working ----------
        API.OrderPlatformPointPayment(tmpData).
            then((data) => {
                console.log(data);
                // {msg: "點數交易成功", platform_point: 21895, code: "22050"}
                // if (data) {
                if (22050 == data.code) {
                    //succ
                    //update platform_point
                    setCookie("point", data.platform_point);
                    // onSend();
                    props.onProjOnShelve(pi, [], props.onFinish);
                } else if (null != data.msg) {
                    alert(data.msg)
                } else {
                    alert("點數交易失敗");
                }

                //     // {
                //     //     formula_text: "(題目數 5 * 樣本數 5 * 性別控樣係數 1.50 * 年齡控樣係數 1.30 * 地區控樣係數 2.00 = 97)"
                //     //     oid: "ORD210824233618"
                //     //     platform_point: 97
                //     //     price: 582
                //     // }
                //     setOrder({ ...data })
                //     setSubStep(2);
                // } else {
                //     alert("Server error");
                // }
            });
    }

    function render4() {
        return (
            <ChargeCalculatorPartApp isShowQCunts={false}
                onSubmit={(data) => { onConditionSet(data, toNext) }}
                onSaveAndBack={(data) => { onConditionSet(data, back) }}
                isEditable={props.isEditable} />
        );
    }

    function getPaymentForm() {
        let paymentForm = null;
        if (formData) {
            paymentForm = (
                <form name='newebpay' action={formData.URL} method="POST" ref={formRef}>
                    <input type="text" name="MerchantID" value={formData.MerchantID} hidden />
                    <input type="text" name="TradeInfo" value={formData.TradeInfo} hidden />
                    <input type="text" name="TradeSha" value={formData.TradeSha} hidden />
                    <input type="text" name="Version" value={formData.Version} hidden />
                    <Button variant="danger" type="submit" hidden>線上結帳</Button>
                </form>
            )
        }
        return paymentForm;
    }

    function render5() {
        let paymentForm = getPaymentForm();

        let cnts = targetData.max_people;
        console.log(targetData);
        if (null == items) {
            return (<div>題目數錯誤</div>);
        }
        let qcnts = items.length;
        if (qcnts < 5) qcnts = 5;

        return (
            <Container className="App mb-50">
                <Card>
                    <Card.Body>
                        <Row>
                            <Col xs={12}><label>{"調查份數: " + cnts}</label></Col>
                            <Col xs={12}><label>{"題目數: " + qcnts}</label></Col>
                            <Col xs={12}><label>性別設定:{Enums.E_GENDER_TEXT[targetData.gender]}</label></Col>
                            <Col xs={12}><label>年齡設定:{Enums.E_AGE_TEXT[targetData.age]}</label></Col>
                            <Col xs={12}><label>地區設定:{Enums.E_AREA_TEXT[targetData.region]}</label></Col>
                            <Col xs={12}><label>折扣:{order.discount}</label></Col>
                            {/* <Col xs={12}><label>{order.formula_text}</label></Col> */}
                            {/* <Col xs={12}><label>折扣:{0}</label></Col> */}
                            <Col xs={12}><label>-----------------------</label></Col>
                            <Col xs={12} className="text-red"><u><strong>本次消耗：{order.platform_point}點<small>&nbsp;or&nbsp;</small>台幣{order.price}元</strong></u></Col>
                            <Col xs={4} className="text-red"><small>約<u>{" " + order.estimate_days + " "}</u>天內完成</small></Col>

                            <Col xs={4} style={{ display: "flex", flexDirection: "column-reverse" }}><Button variant="danger" onClick={onClickOnlinePay}>線上結帳</Button></Col>
                            <Col xs={4} style={{ display: "flex", flexDirection: "column-reverse" }}><Button variant="danger" onClick={onClickPointPay}>{true == isAPISending ? "請稍候.." : "使用點數"}</Button></Col>
                        </Row>
                        {paymentForm}
                        {/* <Row>
                            <Col className="col text-left">
                                <Button onClick={onTest}>開始使用手機測試</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mt-4 col text-center">
                                <Button variant="danger" onClick={onShelf}>{isSending ? "上架中, 請稍候.." : "確定問卷上架"}</Button>
                            </Col>
                        </Row> */}
                    </Card.Body>
                </Card>
            </Container >
        );
    }

    function render5_2() {
        let paymentForm = getPaymentForm();

        return (
            <Container className="App mb-50">
                <Card>
                    <Card.Body>
                        <Row>
                            <Col xs={12} className="text-red">訂單編號：<u>{props.oid}</u></Col>
                            <Col xs={12} className="text-red">狀態：<u>{order.state}</u></Col>
                            <Col xs={12} className="text-red"><u><strong>本次消耗：{order.platform_point}點<small>&nbsp;or&nbsp;</small>台幣{order.price}元</strong></u></Col>

                            <Col xs={{ col: 4, offset: 4 }} style={{ display: "flex", flexDirection: "column-reverse" }}><Button variant="danger" onClick={onClickOnlinePay}>線上結帳</Button></Col>
                            <Col xs={4} style={{ display: "flex", flexDirection: "column-reverse" }}><Button variant="danger" onClick={onClickPointPay}>使用點數</Button></Col>
                        </Row>
                        {paymentForm}
                    </Card.Body>
                </Card>
            </Container >
        );
    }

    function render() {
        // console.log("[!!]", items);
        if (null == props.pdata) {
            return <div>loading...</div>
        } else {
            if (subStep == 1) {
                return render4()
            } else {
                //     if (props.oid) return render5_2();
                return render5()
            }
        }
    }
    return render();
}
